import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { AlertTriangle } from "lucide-react";

export const CardSkeleton = ({ className }) => (
  <div className={cn("rounded-xl border border-line bg-surface p-4", className)}>
    <div className="flex items-center gap-3">
      <Skeleton className="h-9 w-9 rounded-lg bg-white/5" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3 w-1/2 bg-white/5" />
        <Skeleton className="h-6 w-1/3 bg-white/5" />
      </div>
    </div>
    <div className="mt-4 space-y-2">
      <Skeleton className="h-2 w-full bg-white/5" />
      <Skeleton className="h-2 w-4/5 bg-white/5" />
    </div>
  </div>
);

export const RowsSkeleton = ({ rows = 5, className }) => (
  <div className={cn("rounded-xl border border-line bg-surface p-2", className)}>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center gap-3 px-2 py-3">
        <Skeleton className="h-7 w-7 rounded-lg bg-white/5" />
        <Skeleton className="h-3 flex-1 bg-white/5" />
        <Skeleton className="h-3 w-16 bg-white/5" />
        <Skeleton className="h-5 w-20 rounded-full bg-white/5" />
      </div>
    ))}
  </div>
);

export const ErrorState = ({ message = "Não foi possível carregar os dados." }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-err/20 bg-err/5 px-6 py-12 text-center" data-testid="error-state">
    <AlertTriangle className="mb-3 h-7 w-7 text-err" />
    <p className="text-sm font-medium text-foreground">Erro ao carregar</p>
    <p className="mt-1 text-xs text-muted-foreground">{message}</p>
  </div>
);

// Fronteira assíncrona: escolhe skeleton / erro / conteúdo.
export const AsyncBoundary = ({ loading, error, skeleton, children }) => {
  if (loading) return skeleton || <RowsSkeleton />;
  if (error) return <ErrorState />;
  return children;
};
